<template>
  <div class="search-listing hotel-listing" :class="{ 'hide-price' : hidePrice}">
    <div class="flex-items">
      <div class="mobile-image" :style="'background-image: url(' + hotelData.thumbnail_hq.three_hundred_square + ')'"></div>

      <div class="details-col">
        <div class="details-container">
          <div class="image">
            <img 
              v-if="hotelData.thumbnail_hq.length > 0"
              @click="viewHotelListing(hotelData.id, hotelData)" 
              :src="hotelData.thumbnail_hq.three_hundred_square" 
              :alt="hotelData.name" />
            
            <img 
              v-else
              @click="viewHotelListing(hotelData.id, hotelData)" 
              :src="hotelData.thumbnail" 
              :alt="hotelData.name" />
          </div>

          <div class="details">
            <p class="name">
              <span v-if="isBookPage">{{ hotelData.name }}</span>
              <a v-else @click="viewHotelListing(hotelData.id, hotelData)" :title="hotelData.name">{{ hotelData.name }}</a>
            </p>
            <p class="location">
              <span v-if="hotelData.hotel_zone">{{ hotelData.hotel_zone }}</span>
              <span v-else>{{hotelData.address.address_line_one}}, {{ hotelData.address.city_name }}, {{ hotelData.address.state_name }}</span>
              <span class="map">
                <a @click="toggleListingMap()">
                  <i class="fal fa-map-marked"></i>
                  <span v-if="showListingMap == true">{{ $t('hideMap') }}</span>
                  <span v-else>{{ $t('showMap') }}</span>
                </a>
              </span>
            </p>
            <p class="rating">
              <span class="stars" v-if="hotelData.star_rating == 5 || hotelData.star_rating == 4 || hotelData.star_rating == 3 || hotelData.star_rating == 2 || hotelData.star_rating == 1">
                <i v-for="star in hotelData.star_rating" :key="star" class="fa fa-star"></i>
              </span>
              <span class="stars" v-if="hotelData.star_rating == 0.5">
                <i v-for="star in hotelData.star_rating" :key="star" class="fa fa-star-half"></i>
              </span>
              <span class="stars" v-if="hotelData.star_rating == 1.5"><i class="fa fa-star"></i><i class="fa fa-star-half"></i></span>
              <span class="stars" v-if="hotelData.star_rating == 2.5"><i v-for="(n, starIndex) in 2" class="fa fa-star" :key="starIndex"></i><i class="fa fa-star-half"></i></span>
              <span class="stars" v-if="hotelData.star_rating == 3.5"><i v-for="(n, starIndex) in 3" class="fa fa-star" :key="starIndex"></i><i class="fa fa-star-half"></i></span>
              <span class="stars" v-if="hotelData.star_rating == 4.5"><i v-for="(n, starIndex) in 4" class="fa fa-star" :key="starIndex"></i><i class="fa fa-star-half"></i></span>

              <span class="reviews" v-if="hotelData.review_rating">
                <span class="number">{{ hotelData.review_rating }}</span> <strong>{{ hotelData.review_rating_desc }}</strong>
              </span>
            </p>

            <FeaturedAmenities :amenityList="hotelData.amenity_data" />

            <p class="sales-text" v-if="!isBookPage && hotelData.room_data[0].rate_data[0].is_cancellable !== 'false'">
              <i class="fal fa-check"></i> <strong>{{ $t('bookWithoutWorry') }}</strong> {{ $t('freeCancellationWhenBookingThisProperty') }}
            </p>
            <p class="sales-text" v-if="hotelData.room_data[0].rate_data[0].promo_text">
              <i class="fal fa-check"></i> {{ hotelData.room_data[0].rate_data[0].promo_text }}
            </p>

          </div>
        </div>

        
      </div>

      <div class="price-col" v-if="rateData && !hidePrice">
        <p class="price">
          {{ rateData.display_price | formatCurrency(rateData.display_currency, 0) }}
        </p>
        <p class="label">{{ $t('perNight') }}</p>
        
        <button class="btn btn-lg" @click="viewHotelListing(hotelData.id, hotelData)" :title="$t('bookNow')">{{ $t('bookNow') }}</button>
      </div>
    </div>

    <div class="hotel-map" v-if="showListingMap">
        <GmapMap
          :center="mapCoordinates"
          :zoom="15"
          :draggable="false"
          :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUI: false
          }"
          style="width: 100%; height: 200px; border-radius: 0 0 3px 3px;"
          >

            <GmapMarker
                :position="mapCoordinates"
                :clickable="false"
                :draggable="false"
            />
          
        </GmapMap>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import FeaturedAmenities from '@/components/hotels/FeaturedAmenities';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAvOui5WXHrnzXDrOu28XigebQdefkwL5Q',
    libraries: 'places'
  }
})

export default {
  name: 'HotelListing',
  data () {
    return {
      showListingMap: false
    }
  },

  methods: {
    viewHotelListing(hotelID, hotelData) {
      this.$store.dispatch('saveHotelResult', hotelData);
      let params = this.$route.params;
      params.id = hotelID;
      this.$router.push({ name: 'HotelListing', params: params, query: this.$route.query});
    },

    toggleListingMap() {
      let self = this;

      self.showListingMap = !self.showListingMap;

    }
  },

  computed: {
    mapCoordinates() {
      return { lat: parseFloat(this.hotelData.geo.latitude), lng: parseFloat(this.hotelData.geo.longitude) };
    }
  },

  components: {
    FeaturedAmenities
  },

  props: {
    hotelData: Object,
    rateData: Object,
    hidePrice: Boolean,
    cancelPolicy: String,
    isBookPage: Boolean
  }
}
</script>